import { useTheme } from '@vebox/etui-system';
import '../../utilities/format-ms.js';
import '../../utilities/create-transition.js';
import { createElement } from 'react';
import '../../utilities/get-styleprop.js';
import '../../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import '../../Svg-0180d7b5.js';
import Icon from '../../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../../Icon/icons.js';
import '../../Icon/helper.js';
import '@vebox/etui-colors';
import 'react-dom';
import '../../ClickOutside/ClickOutside.js';
import '../../Tooltip/Tooltip.js';
import '../../Button/Button.js';
import 'react-popper';
import DropdownMenu from '../../DropdownMenu/DropdownMenu.js';
import '../../DropdownMenu/Item.js';
import '../../DropdownMenu/Divider.js';

const ItemDropdown = ({
  onMarkFavorite,
  onUnmarkFavorite,
  markFavoriteLabel,
  unmarkFavoriteLabel,
  isFavorite
}) => {
  const theme = useTheme();
  return /*#__PURE__*/createElement(DropdownMenu, {
    styles: {
      root: {
        position: 'absolute',
        right: 0,
        top: 0
      },
      menuContainer: {
        zIndex: 2
      }
    },
    renderButton: ({
      openDropdown,
      ref
    }) => {
      return /*#__PURE__*/createElement(Div
      // @ts-ignore
      , {
        elRef: ref,
        cursor: "pointer",
        onClick: e => {
          e.stopPropagation();
          openDropdown();
        }
      }, /*#__PURE__*/createElement(Icon, {
        size: 24,
        glyph: icons.DOTS_VERTICAL,
        styles: {
          root: {
            color: theme.palette.secondary.main
          }
        }
      }));
    },
    placement: "right",
    renderList: ({
      closeDropdown
    }) => /*#__PURE__*/createElement(DropdownMenu.Item, {
      onClick: () => {
        isFavorite ? onUnmarkFavorite() : onMarkFavorite();
        closeDropdown();
      },
      styles: {
        root: {
          height: '30px',
          p: `${theme.spacing.md}px !important`
        }
      }
    }, /*#__PURE__*/createElement(Icon, {
      glyph: isFavorite ? icons.STAR : icons.STAR_FILLED,
      styles: {
        root: {
          mr: `${theme.spacing.xxs}px`
        }
      },
      size: 16
    }), isFavorite ? unmarkFavoriteLabel : markFavoriteLabel)
  });
};

export default ItemDropdown;
